module.exports = __webpack_public_path__ + "static/media/AmsterdamOne.00258dea.ttf";